<template>
  <GridsTwelveGrid>
    <h4 class="col-span-full col-start-1 space-y-4 laptop:col-span-6 laptop:col-start-6">
      {{ $t("contact-form") }}
    </h4>
    <form
      class="col-span-full col-start-1 mt-6 flex flex-col laptop:col-span-6 laptop:col-start-6"
      @submit.prevent="submitForm"
      ref="contactForm"
    >
      <!--TODO: Validate Name-->
      <ContactContactFormInput
        type="text"
        name="fname"
        :label="$t('your-name')"
        icon="icon-park-outline:edit-name"
        v-model:value="data.name"
        ref="name"
      />
      <!--TODO: Validate email-->
      <ContactContactFormInput
        type="email"
        name="email"
        :label="$t('your-email')"
        icon="fluent:mail-16-regular"
        v-model:value="data.email"
        ref="email"
      />
      <!--TODO: Validate company-->
      <ContactContactFormInput
        type="text"
        name="company"
        :label="$t('your-company')"
        icon="carbon:location-company"
        v-model:value="data.company"
        ref="company"
      />
      <ContactContactFormSelect
        :options="contactOptions"
        v-model:value="data.recipient"
        @update:value="(value) => updateRecipient(value)"
      />

      <!--TODO: Validate Message-->
      <ContactContactFormTextArea
        :rows="10"
        :label="$t('message')"
        name="message"
        class="mt-4"
        v-model:value="data.message"
      />

      <vue-recaptcha
        class="mt-4"
        ref="recaptcha"
        sitekey="6LeSAE0kAAAAAE3AlgZT5oi4fW9812PZ9CTVNUwJ"
        @verify="recaptchaVerify"
        @expired="recaptchaExpired"
        @error="recaptchaError"
      />

      <button
        type="submit"
        class="mt-4 self-start rounded-sm border border-ng10 bg-transparent px-12 py-[17px] text-base leading-[1.2] text-ng800 transition duration-200 ease-out hover:border-[#8AA678] hover:outline-none hover:ring-1 hover:ring-[#8AA678] focus:border-[#8AA678] focus:outline-none focus:ring-1 focus:ring-[#8AA678] active:border-[#6a86588] active:outline-none active:ring-1 active:ring-[#6a8658]"
      >
        {{ $t("send") }}
      </button>
    </form>
  </GridsTwelveGrid>
</template>
<script setup lang="ts">
import { useNotification } from "@kyvg/vue3-notification";
import { VueRecaptcha } from "vue-recaptcha";
import { ContactContactFormInput } from "#components";

const { t } = useI18n();
const { t: $t } = useI18n();

const contactForm = ref();

const name = ref<InstanceType<typeof ContactContactFormInput>>();

const contactOptions = [
  { id: 0, name: $t("general-department"), key: "test1" },
  { id: 1, name: $t("engineering-department"), key: "test2" },
  { id: 2, name: $t("sales-department"), key: "tes1" },
  { id: 3, name: $t("marketing-department"), key: "tes2" },
  { id: 4, name: $t("hr-department"), key: "test1" },
  { id: 5, name: $t("legal-department"), key: "test2" },
];

const recipient = ref(contactOptions[0]);

const recipientKey = computed(() => recipient.value?.key || "");

const data = ref({
  name: "",
  email: "",
  company: "",
  message: "",
  recipient: recipient.value,
  recaptcha: "",
});

const submitForm = () => {
  const notification = useNotification();

  formRequest()
    .then((result: ContactFormResult) => {
      if (result.Result === "OK") {
        notification.notify({
          title: t("thank-you-for-your-message"),
          type: "success",
        });
        contactForm.value.reset();
        recaptcha.value.reset();
      } else if (result.ErrorCode === "missing_fields") {
        notification.notify({
          title: t("please-fill-all-required-fields"),
          type: "warn",
        });

        recaptcha.value.reset();
      } else {
        notification.notify({
          title: t("an-error-occurred-please-try-again-later"),
          type: "error",
        });
        recaptcha.value.reset();
      }
    })
    .catch((error) => {
      notification.notify({
        title: t("an-error-occurred-please-try-again-later"),
        type: "error",
      });
    });
};

const updateRecipient = (value: { id: number; name: string; key: string }) => {
  recipient.value = value;
};

const formRequest = async () => {
  const formData = new FormData();

  const toSend = {
    fmmode: "ajax",
    FullName: data.value.name,
    EmailAddr: data.value.email,
    Company: data.value.company,
    mesg: data.value.message,
    recipients: recipientKey.value,
    subject: t("new-mail-submission"),
    derive_fields:
      "email=EmailAddr,realname=FullName,replyto=EmailAddr,imgverify=g-recaptcha-response,arverify=g-recaptcha-response",
    mail_options: "Exclude=email;realname;replyto",
    "g-recaptcha-response": data.value.recaptcha,
  };

  for (let key in toSend) {
    formData.append(key, toSend[key]);
  }

  return await $fetch<ContactFormResult>("https://contact.intercomm.cgworks.eu/formmail.php", {
    // headers: {
    //   "Content-Type": "application/json",
    // },
    method: "POST",
    body: formData,
  });
};

const recaptcha = ref();

const recaptchaVerify = (response: string) => {
  data.value.recaptcha = response;
};

const recaptchaExpired = () => {
  data.value.recaptcha = "";
};

const recaptchaError = () => {
  data.value.recaptcha = "";
};
</script>
<style lang="scss" scoped></style>
